import API from '../../../../../services/api';

export const NOTAS_CARGO_API = {
    get: async (page = 1, search = null) => {
        return await API.get(`/nota-cargo?page=${page}${search || ''}`).then(res => res.data);
    },
    new: async (nota) => {
        return API.post('/nota-cargo', nota).then(res => res.data);
    },
    getPDF: async (idNota) => {
        return API.get(`/nota-cargo/generate_pdf/${idNota}`).then(res => res.data);
    },
    delete: async (idNota) => {
        return API.delete(`/nota-cargo/${idNota}`).then(res => res.data);
    },
    editNota: async (idNota, total_iva) => {
        return API.put('/nota-cargo/' + idNota, {total_iva}).then(res => res.data);
    },
    regenerateNota: async (nota_id) => {
        return API.post('/notas-s3', {nota_id}).then(res => res.data);
    }
}